import * as d3 from 'd3'
import moment from 'moment'
export default {

  methods: {

    gmx_BandScaleValues_Week(_data) {
      // Setting initial
      this.timeline.week  = []
      this.timeline.month = []
      this.timeline.year  = []

        // Pre-processing for week 
        _data.forEach((d,i)=> {
        d.yyyymm = d.CDATE.substr(0,7)
        d.year = d.CDATE.substr(0,4)
        d.mx = this.timeline.axis(d.CDATE) + this.timeline.axis.bandwidth()/2

        this.timeline.week.push({
          cDate: d.CDATE,
          name: d.CDATE.substr(8,2),
          sx: this.timeline.axis(d.CDATE),
          mx: d.mx,
          ex: this.timeline.axis(d.CDATE) + this.timeline.band,
        })
      })

      // Pre-processing for month 
      let unique_Month = [ ...new Set(_data.map(m => m.yyyymm)) ]
      unique_Month.forEach((d,i)=> {
        let start = this.timeline.axis(_data.find(f=> f.yyyymm == d).CDATE)
        let end = this.timeline.axis(_data.findLast(f=> f.yyyymm == d).CDATE) + this.timeline.band
        // this.timeline.month.push({
        //   name: new Date(`${unique_Month[i]}`).toLocaleDateString("en-US", {month: "short"}),
        //   num: new Date(`${unique_Month[i]}`).getMonth()+1,
        //   sx: start,
        //   mx: start + (end - start) / 2,
        //   ex: end,
        // })

        // `yyyymm` is a calendar-month key, so parse its month without creating a timezone-dependent Date.
        const monthNumber = Number(d.slice(5, 7))
        this.timeline.month.push({
          name: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][monthNumber - 1],
          num: monthNumber,
          sx: start,
          mx: start + (end - start) / 2,
          ex: end,
        })
      })

      // Pre-processing for year 
      let unique_Year = [ ...new Set(_data.map(m => m.year)) ]
      unique_Year.forEach((d,i)=> {
        let start = this.timeline.axis(_data.find(f=> f.year == d).CDATE)
        let end = this.timeline.axis(_data.findLast(f=> f.year == d).CDATE) + this.timeline.band
        this.timeline.year.push({
          name: unique_Year[i],
          sx: start,
          mx: start + (end - start) / 2,
          ex: end,
        })
      })
    },


    gmx_BandScaleValues_Month(_data) {
      // Pre-processing for month 
      _data.forEach((d,i)=> {

        d.yyyymm = d.CDATE.substr(0,7)
        d.year = d.CDATE.substr(0,4)
        d.mx = this.timeline.axis(d.CDATE) + this.timeline.axis.bandwidth()/2
        const monthNumber = Number(d.yyyymm.slice(5, 7))

        this.timeline.month.push({
          name: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][monthNumber - 1],
          num: monthNumber,
          eDate: d.CDATE,
          yyyymm: d.yyyymm,
          sx: this.timeline.axis(d.CDATE),
          mx: d.mx,
          ex: this.timeline.axis(d.CDATE) + this.timeline.axis.bandwidth(),
        })
      })

      // Pre-processing for year 
      let unique_Year = [ ...new Set(_data.map(m => m.year)) ]

      unique_Year.forEach((d,i)=> {
        let start = this.timeline.axis(_data.find(f=> f.year == d).CDATE)
        let end = this.timeline.axis(_data.findLast(f=> f.year == d).CDATE) + this.timeline.band
        this.timeline.year.push({
          name: unique_Year[i],
          sx: start,
          mx: start + (end - start) / 2,
          ex: end,
        })
      })
    },


    gmx_TimelineValues(d_, type_) {

      let sDate_ = moment(d_.startDate).toDate()
      let eDate_ = moment(moment(d_.endDate).format('YYYY-MM-DD 23:59:59')).toDate()
      let weekNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      let cutoff_Week = weekNames.findIndex(n_ => n_ == d_.weekEnd)

      let diff_ = cutoff_Week - sDate_.getDay()
      sDate_ = moment(sDate_).add(diff_ < 0 ? 7 + diff_ : diff_, 'days').toDate()

      diff_ = cutoff_Week - eDate_.getDay()
      eDate_ = moment(eDate_).add(diff_ < 0 ? 7 + diff_ : diff_, 'days').toDate()

      // Day
      if(type_ == 'day') {
        let nextDay = moment(moment(sDate_).format('YYYY-MM-DD 23:59:59')).toDate()
        while(nextDay <= eDate_) {
          let value_ = {
            cDate: moment(nextDay).format('YYYY-MM-DD'),
            name: moment(nextDay).format('D')
          }
          this.timeline.day.push({ value: 0, ...value_ })
          nextDay = moment(nextDay).add(1, 'days').toDate()
        }
      }

      // Week
      let nextDate = moment(moment(sDate_).format('YYYY-MM-DD 23:59:59')).toDate()
      while(nextDate <= eDate_) {
        let value_ = {
          sDate: moment(moment(nextDate).add(-6, 'days').format('YYYY-MM-DD')).toDate(),
          mDate: null,
          eDate: nextDate
        }
        value_.mDate = new Date(d3.mean([value_.sDate, value_.eDate]))
        this.timeline.week.push({ name: value_.eDate.getDate(), ...value_ })
        nextDate = moment(nextDate).add(7, 'days').toDate()
      }

      // Month
      eDate_ = null
      let months_ = []
      let months__ = []
      this.timeline.week.forEach((w_, i) => {
        if(eDate_ != d3.timeFormat('%Y-%m')(w_.eDate)) {
          eDate_ = d3.timeFormat('%Y-%m')(w_.eDate)
          if(i > 0) {
            months_.push(months__)
            months__ = []
          }
        }
        months__.push(w_)
        if(i === this.timeline.week.length - 1) months_.push(months__)
      })
      months_.forEach(m_ => {
        this.timeline.month.push({
          name: d3.timeFormat('%b')(m_[0].eDate), 
          sDate: m_[0].sDate, 
          mDate: new Date(d3.mean([ m_[0].sDate, m_[m_.length - 1].eDate ])),
          eDate: m_[m_.length - 1].eDate
        })
      })

      // Year
      eDate_ = null
      let years_ = []
      let years__ = []
      this.timeline.week.forEach((w_, i) => {
        if(eDate_ != d3.timeFormat('%Y')(w_.eDate)) {
          eDate_ = d3.timeFormat('%Y')(w_.eDate)
          if(i > 0) {
            years_.push(years__)
            years__ = []
          }
        }
        years__.push(w_)
        if(i === this.timeline.week.length - 1) years_.push(years__)
      })
      years_.forEach(m_ => {
        this.timeline.year.push({
          name: d3.timeFormat('%Y')(m_[m_.length - 1].eDate), 
          sDate: m_[0].sDate, 
          mDate: new Date(d3.mean([ m_[0].sDate, m_[m_.length - 1].eDate ])),
          eDate: m_[m_.length - 1].eDate
        })
      })

      this.timeline.scale = d3.scaleTime()
      .domain([
        this.timeline.week[0].sDate, 
        this.timeline.week[this.timeline.week.length - 1].eDate
      ])
      .rangeRound([0, this.timeline.length])
    },


    gmx_TimelineValues_Gantt(d_, type_) {

      let sDate_ = moment(d_.startDate).startOf('month').toDate()
      let eDate_ = moment(moment(d_.endDate).endOf('month').format('YYYY-MM-DD 23:59:59')).toDate()
      let weekNames = ['sunday', 'monday', 'tuesday', 'wednesday ', 'thursday', 'friday', 'saturday']
      let cutoff_Week = weekNames.findIndex(n_ => n_ == d_.weekEnd)

      // Day
      if(type_ == 'day') {
        let nextDay = moment(moment(sDate_).format('YYYY-MM-DD 23:59:59')).toDate()
        while(nextDay <= eDate_) {
          let value_ = {
            cDate: moment(nextDay).format('YYYY-MM-DD'),
            name: moment(nextDay).format('D')
          }
          this.timeline.day.push({ value: 0, ...value_ })
          nextDay = moment(nextDay).add(1, 'days').toDate()
        }
      }

      // Month
      let currentMonth = moment(sDate_).startOf('month')
      while(currentMonth.isBefore(eDate_)) {
        let mStart = currentMonth.toDate()
        let mEnd = moment(currentMonth).endOf('month').toDate()
        mEnd = moment(moment(mEnd).format('YYYY-MM-DD 23:59:59')).toDate()

        this.timeline.month.push({
          name: d3.timeFormat('%b')(mStart),
          sDate: mStart,
          mDate: new Date(d3.mean([mStart, mEnd])),
          eDate: mEnd
        })
        currentMonth.add(1, 'months')
      }

      // Year
      let currentYear = moment(sDate_).startOf('year')
      while(currentYear.isBefore(eDate_)) {
        let yStart = currentYear.toDate()
        let yEnd = moment(currentYear).endOf('year').toDate()
        yEnd = moment(moment(yEnd).format('YYYY-MM-DD 23:59:59')).toDate()

        let actualStart = yStart < sDate_ ? sDate_ : yStart
        let actualEnd = yEnd > eDate_ ? eDate_ : yEnd

        this.timeline.year.push({
          name: d3.timeFormat('%Y')(yStart),
          sDate: actualStart,
          mDate: new Date(d3.mean([actualStart, actualEnd])),
          eDate: actualEnd
        })
        currentYear.add(1, 'years')
      }

      this.timeline.scale = d3.scaleTime()
      .domain([sDate_, eDate_])
      .rangeRound([0, this.timeline.length])
    },

    
    gmx_TimelineValues_Multi(_data) {

      let startDate = moment(`${_data.startDate} 00:00:00`).toDate()
      let endDate = moment(`${_data.endDate} 23:59:59`).toDate()
      
      let noOfYear = endDate.getYear() - startDate.getYear()
      let noOfMonth = endDate.getMonth() - startDate.getMonth() + (noOfYear*12)

      // Year
      let prevYearDate_ = startDate
      for(var i=0; i<noOfMonth; i++) {

        let _nextMonthDate__ = new Date(new Date(startDate).setMonth(startDate.getMonth() + i))
        if(d3.timeFormat('%Y')(prevYearDate_) != d3.timeFormat('%Y')(_nextMonthDate__)) {
          let midDateYear_ = new Date(
            d3.mean([
              prevYearDate_,
              new Date(new Date(_nextMonthDate__).setMonth(_nextMonthDate__.getMonth() + 0) - 1)
            ])
          )
          _data.year.push({ name: d3.timeFormat('%Y')(midDateYear_), midDate: new Date(midDateYear_) })
          prevYearDate_ = _nextMonthDate__
        }
      }

      // Month
      let midDateYear_ = new Date(d3.mean([prevYearDate_, endDate]))
      _data.year.push({ name: d3.timeFormat('%Y')(midDateYear_), midDate: new Date(midDateYear_) })

      for(i=0; i<=noOfMonth; i++) {
        let _nextMonthDate__ = new Date(new Date(startDate).setMonth(startDate.getMonth() + i))
        let endMonth_ = new Date(new Date(_nextMonthDate__).setMonth(_nextMonthDate__.getMonth() + 1) - 1)
        let midDate_ = new Date(d3.mean([_nextMonthDate__, endMonth_]))
        
        _data.month.push({
          name: d3.timeFormat('%b')(midDate_),
          midDate: new Date(midDate_),
          endDate: endMonth_
        })
      }
      _data.width = _data.month.length * _data.monthWidth
      _data.scale = d3.scaleTime()
      .domain([startDate, endDate])
      .range([0, _data.width])
      return _data
    },

    
    get_lastDayMonth(date_) {
      let today = new Date(date_)
      let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)

      lastDay = moment(moment(lastDay).format('YYYY-MM-DD 23:59:59')).toDate()
      return lastDay
    },


    gmx_BandToScale_Month(_date) {

      let end = this.timeline.month.find(f=> f.yyyymm == _date.substr(0,7))
      let toIdx = this.timeline.month.findIndex(f=> f.yyyymm == _date.substr(0,7))

      if(_date > end.eDate) end = this.timeline.month[toIdx + 1]

      let start = this.timeline.month[toIdx-1]
      let noDays = this.gmx_dateDiff(end.eDate,start.eDate)
      let length = end.ex - end.sx
      let dayLen = length/noDays

      let x = end.sx + this.gmx_dateDiff(_date,start.eDate)*dayLen
      return x
    },

    gmx_BandToScale_Week(_date) {

      let d = (_date instanceof Date) ? _date : d3.timeParse('%Y-%m-%d')(_date)

      let weekDates = this.timeline.week.map(w => ({
        ...w,
        cDateObj: (w.cDate instanceof Date) ? w.cDate : d3.timeParse('%Y-%m-%d')(w.cDate)
      }))

      let closest = weekDates.reduce((early, late) => {
        let earlyDay = Math.abs(early.cDateObj - d)
        let lateDay = Math.abs(late.cDateObj - d)
        return lateDay < earlyDay ? late : early
      })

      let diffDays = Math.round((d - closest.cDateObj) / 86400000)
      let dayLen  = (closest.ex - closest.sx) / 7

      let x = closest.ex
      if (diffDays < 0) x = closest.ex + diffDays * dayLen
      else if (diffDays > 0) x = closest.ex + diffDays * dayLen

      return x
    },    
  }
}
